export default "__VITE_PUBLIC_ASSET__662323ab__"